<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Confirmar reportes</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 sm3>
                <empresa-select v-model="d.empresa_id" @change="show" @input="getDepositos"></empresa-select>
            </v-flex>
            <v-flex xs12 sm3>
                <v-menu
                        lazy
                        :close-on-content-click="false"
                        v-model="menuFecha"
                        :return-value.sync="menuFecha"
                        ref="menuFecha"
                >
                    <v-text-field
                            name="fecha"
                            slot="activator"
                            label="Fecha"
                            v-model="d.fecha"
                            prepend-icon="event"
                            readonly
                    ></v-text-field>
                    <v-date-picker
                            v-model="d.fecha"
                            first-day-of-week="1"
                            locale="es-sp"
                            scrollable
                            @input="$refs.menuFecha.save(d.fecha)"
                            @change="show()"
                    ></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs12 sm3>
                <v-select label="Reportar a deposito" v-model="d.deposito" :items="depositos" item-value="id" item-text="desig"></v-select>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        hide-actions
                        class="tabla-compacta-col"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">
                            <v-tooltip top>
                                <v-icon slot="activator" v-if="props.item.saldos.length > 0" color="red">warning</v-icon>
                                <span>Falta de stock</span>
                            </v-tooltip>
                            {{ props.item.C2_NUM + ' ' + props.item.C2_ITEM + ' ' + props.item.C2_SEQUEN}}
                        </td>
                        <td class="text-xs-center">
                            <v-tooltip top>
                                <span slot="activator">{{ props.item.C2_PRODUTO }}</span>
                                <span>{{ props.item.B1_DESC }}</span>
                            </v-tooltip>
                        </td>
                        <td class="text-xs-center">
                            {{ props.item.C2_PEDIDO }} {{ props.item.C2_ITEMPV }}
                        </td>
                        <td class="text-xs-center">
                            <v-tooltip top>
                                <span slot="activator">{{ props.item.A1_NOME }}</span>
                                <span>{{ props.item.C5_CLIENT }}</span>
                            </v-tooltip>
                        </td>
                        <td class="text-xs-center" v-html="props.item.C2_LOCAL"></td>
                        <td class="text-xs-center">
                            {{ props.item.C2_QUANT | moneda }} {{ props.item.C2_UM }}
                        </td>
                        <td class="text-xs-center">
                            {{ props.item.PZAS | moneda }}
                        </td>
                        <td class="text-xs-center">
                            {{props.item.B1_ANCHO | moneda }}
                        </td>
                        <td class="text-xs-center">
                            {{ props.item.C2_LARGPZA | moneda }}
                        </td>
                        <td class="text-xs-center">
                            <b>{{ props.item.C2_QUJE | moneda }} {{ props.item.C2_UM }}</b>
                        </td>
                        <td class="text-xs-center">
                            <b>{{ props.item.C2_REPWEB | moneda }} {{ props.item.C2_UM }}</b>
                        </td>
                        <td class="text-xs-center">
                            <b>{{ props.item.PZAREPWEB | moneda }}</b>
                        </td>
                        <td class="text-xs-center">
                            <v-btn flat icon color="green" @click="confirmar(props.item)" :loading="confirmando === props.item.op_id">
                                <v-icon>check</v-icon>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import mixinEmpresa from '../../mixins/empresa';
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import moneda from '../../filters/moneda';
    import moment from 'moment'
    import {mapActions} from 'vuex';

    export default {
        name: "confirmar",
        mixins: [mixinEmpresa],
        components: {empresaSelect},
        filters: {moneda},
        data() {
            return {
                depositos: [],
                menuFecha: false,
                d: {
                    fecha: '',
                    empresa_id: '',
                    deposito: ''
                },
                headers: [
                    {text: 'OP', value: 'C2_NUM', align: 'center'},
                    {text: 'PRODUCTO', value: 'C2_PRODUTO', align: 'center'},
                    {text: 'PEDIDO | ITEM', value: 'C2_PEDIDO', align: 'center'},
                    {text: 'CLIENTE', value: 'C5_CLIENT', align: 'center'},
                    {text: 'DEPOSITO', value: 'C2_LOCAL', align: 'center'},
                    {text: 'CANT OP', value: 'C2_QUANT', align: 'center'},
                    {text: 'CANT PZAS', value: 'PZAS', align: 'center'},
                    {text: 'ANCHO', value: 'B1_ANCHO', align: 'center'},
                    {text: 'LARGO PZA', value: 'C2_LARGPZA', align: 'center'},
                    {text: 'REP', value: 'C2_QUJE', align: 'center'},
                    {text: 'REP WEB', value: 'C2_REPWEB', align: 'center'},
                    {text: 'PZA REP WEB', value: 'PZAREPWEB', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ],
                items: [],
                loading: false,
                confirmando: -1
            }
        },
        watch: {
            'd.deposito'(value) {
                this.$ls.set('pcp.confirmar.deposito', value);
            }
        },
        mounted() {
            this.d.deposito = this.$ls.get('pcp.confirmar.deposito', '');
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            getDepositos() {
                this.empresaDepositos(this.d.empresa_id, r => {
                    this.depositos = r;
                }, err => console.log(err));
            },
            show() {
                if (!this.d.empresa_id || !this.d.fecha) {
                    return false;
                }
                this.loading = true;
                this.$http.post('pcp/ord-prod/reportes-web', this.d)
                    .then(r => {
                        this.items = r.data;
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = true;
                    })
            },
            confirmar(item) {
                if (!this.d.empresa_id || !this.d.fecha || !this.d.deposito) {
                    return false;
                }
                let depIndx = this.depositos.findIndex(el => {
                    return el.id === this.d.deposito;
                });
                this.confirmando = item.op_id;
                this.$http.post('pcp/ord-prod/reportar-micro', {
                    repWebId: item.reporte.id,
                    emp: this.d.empresa_id,
                    C2_LARGOPZA: item.C2_LARGPZA,
                    H6_OP: item.C2_NUM + item.C2_ITEM + item.C2_SEQUEN,
                    H6_PRODUTO: item.C2_PRODUTO,
                    H6_DATAINI: moment(this.d.fecha).format('YYYYMMDD'),
                    H6_DATAFIN: moment(this.d.fecha).format('YYYYMMDD'),
                    H6_QTDPROD: item.C2_REPWEB,
                    H6_DTAPONT: moment().format('YYYYMMDD'),
                    H6_LOCAL: this.depositos[depIndx].desig,
                    H6_PT: (item.C2_QUANT === item.C2_REPWEB) ? 'T ' : 'P',
                    H6_CALIDAD: item.CALIDAD,
                    H6_RECURSO: item.reporte.recurso_id
                })
                    .then(r => {
                        this.msjShow(r.data);
                        if(r.data.tipo === 1){
                            this.show();
                        }
                        this.confirmando = -1;
                    })
                    .catch(err => {
                        this.confirmando = -1;
                    })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/pcp/confirmar.vue